import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { hasRelationship } from 'Helpers/Affordances';
import { useHistory } from 'react-router-dom';

export default function usePageHandleRedirectOnClose() {
  const { pageContentResource, loadPageContentLink } = usePageContentContext();
  const history = useHistory();

  const hasRelationshipRedirectOnClose = hasRelationship(pageContentResource, fr.relationships.redirectOnClose.name);

  const handleRedirectOnClose = async () => {
    if (hasRelationshipRedirectOnClose) {
      await loadPageContentLink(pageContentResource.relationship(fr.relationships.redirectOnClose.name).link('related'));
    } else {
      // Fallthrough case - unsure where to navigate to go to dashboard
      history.push('/');
    }
  };

  return {
    hasRelationshipRedirectOnClose,
    handleRedirectOnClose,
  };
}
